<script>
    import Image from '@project/components/Image.svelte'
    import { spring } from 'svelte/motion'
    import { dim } from '@project/utils'
    
    let urlPrefix = "/roxerdigital/404/";

    const { w, h } = dim()

    let el

    let c = spring({
        x1: w / 2,
        y1: -h / 2,
        x2: w,
        y2: h * 2,
        x3: w,
        y3: -h,
    }, {
        stiffness: 0.1,
        damping: 0.4
    })

    const load = (e) => {
        el = e.detail
        calcPolygon(e.detail)
    }

    const resize = () => {
        calcPolygon(el)
    }

    const calcPolygon = (element) => {
        if (!element) return

        setTimeout(() => {
            const m = - 1
            const b = element.getBoundingClientRect()
            if (element) {
                const y = b.top
                const x = b.left + (b.width * 0.09)

                const { w, h } = dim()
                const i = h - y
                c.set({
                    x1: x - i,
                    y1: y - i,
                    x2: x + w * 5,
                    y2: y + w * 5,
                    x3: x + w * 5,
                    y3: -y,
                })
            }
        }, 60)
    }
</script>

<svelte:head>
    <style>
        html,
        body {
            height: 100%;
        }

        body {
            background: #fffeff;
        }
    </style>
</svelte:head>

<svelte:window on:scroll={resize} on:resize={resize}></svelte:window>

<main class="h-full flex flex-col">
    <svg class="fixed -z-1" height="100%" width="100%">
        <path d="M {$c.x1} {$c.y1} L {$c.x2} {$c.y2} L {$c.x3} {$c.y3}" style="fill:#d6d900;" />
    </svg>
    <header class="flex flex-col items-center">
        <div class="w-full max-w-xl mt-24">
            <Image on:load={load} height="369" jpg="{urlPrefix}media/Baseball_poster.jpg" mp4="{urlPrefix}media/Baseball_404.mp4"  webm="{urlPrefix}media/Baseball_404.webm"/>
        </div>
    </header>
    <section class="fix h-full flex justify-center text-base md:text-xl leading-relaxed text-roxerblack mt-12 uppercase">
        <div class="px-4 mb-12">
            <p class="pl-8"><b class="font-black">Ezt most brutál</b> elütötted!</p>
            <p class="my-1"><b class="font-black">A stadion tombol, </b></p>
            <p class="pl-16">de inkább <b class="font-black">próbálkozz újra!</b></p>
        </div>
    </section>
    <footer class="text-center pb-4">
        <a class="inline-block" href="https://roxer.hu/">
            <img alt="A Roxer logója" class="w-8 md:w-12" src="{urlPrefix}media/roxer_logo_dark.png">
        </a>
    </footer>
</main>

<style>
    .img {
        max-width: 5em;
    }

    @supports (-webkit-overflow-scrolling: touch) {
        .fix {
            margin-top: 18.25em;
        }
    }
</style>